<div>
    <ng-container *ngFor="let facet of displayableFacets; trackBy: trackById; index as i">
        <div class="border-b border-gray-200 py-3">
            <h3 class="-my-3 flow-root">
                <!-- Expand/collapse section button -->
                <button
                    type="button"
                    class="py-3 bg-white w-full flex items-center justify-between text-sm text-gray-400 hover:text-gray-500 focus-visible:ring-primary-400 focus-visible:ring-2 focus:outline-none"
                    [attr.aria-controls]="'filter-section-' + i"
                    [attr.aria-expanded]="isExpanded(facet)"
                    (click)="toggleExpanded(facet.id)"
                >
                    <span class="font-medium text-gray-900">
                        {{ facet.name | titlecase }}
                    </span>
                    <span class="ml-6 flex items-center">
                        <svg
                            [class.hidden]="isExpanded(facet)"
                            class="h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <svg
                            [class.hidden]="!isExpanded(facet)"
                            class="h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </span>
                </button>
            </h3>
            <!-- Filter section, show/hide based on section state. -->
            <div class="pt-3" [class.hidden]="!isExpanded(facet)" [id]="'filter-section-' + i">
                <div class="space-y-1 max-h-96 overflow-y-auto">
                    <div *ngFor="let value of facet.values" class="flex items-center">
                        <a
                            [routerLink]="['./']"
                            [queryParams]="{ facets: toggleFacetValueId(facet.id, value.id), p: 1 }"
                            [queryParamsHandling]="'merge'"
                            [state]="{ noScroll: true }"
                        >
                            <kb-checkbox
                                [isChecked]="value.isActive"
                                [isDisabled]="value.count === 0"
                                [label]="value.name"
                            >
                            </kb-checkbox>
                            <span
                                class="inline-flex items-center px-2 py-0 rounded-full text-xs font-medium bg-gray-100 text-gray-600"
                            >
                                {{ value.count }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <h3 class="font-medium text-sm text-gray-900 my-6">
        Price range
    </h3>
    <kb-price-range-inputs (rangeChange)="setPriceRange($event)" [min]="min$ | async" [max]="max$ | async">
    </kb-price-range-inputs>
</div>
